import { Loader2 } from "lucide-react";

/** Inline loading state used inside modals and Suspense boundaries. */
const Loader = () => (
	<div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2.5 tw-py-10">
		<Loader2 className="tw-h-6 tw-w-6 tw-animate-spin tw-text-teal" />
		<p className="tw-text-[13px] tw-text-text-soft">Fetching data, please wait...</p>
	</div>
);

export default Loader;
